import { render, staticRenderFns } from "./commentsItemBox.vue?vue&type=template&id=0de31680&scoped=true&"
import script from "./commentsItemBox.vue?vue&type=script&lang=js&"
export * from "./commentsItemBox.vue?vue&type=script&lang=js&"
import style0 from "./commentsItemBox.vue?vue&type=style&index=0&id=0de31680&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de31680",
  null
  
)

export default component.exports